import style from "./style.module.css"
import {useEffect, useRef} from "react"

import vipaLogo from "../../../images/logo_vipa.png"
import dropdownImg from "../../../images/dropdown_paws.svg"
import whatsappIcon from "../../../images/icon_whatsapp.svg"

export default function NavBar(props) {



    const hambContentRef = useRef()
    const navRef = useRef()
    const handleHambContent = () => {
        hambContentRef.current.classList.toggle(style.active)
    }

    const getDropDownHeight = () =>{

      if(navRef && navRef.current && navRef.current.clientHeight){
        let navHeight = navRef.current.clientHeight;
        hambContentRef.current.style.height = `calc(100.5dvh - ${navHeight}px)`;      }


    }

    window.addEventListener("resize", getDropDownHeight)


    useEffect(() => {
        getDropDownHeight();
    }, []);


    return (
        <div className={style.navbarDiv}>
            <div className={style.navbar} ref={navRef}>
                <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.3.0/css/all.min.css"
                    integrity="sha512-SzlrxWUlpfuzQ+pcUCosxcglQRNAq/DZjVsC0lE40xsADsfeQoEypE+enwcOiGjk/bSuGGKHEyjSoQ1zVisanQ=="
                    crossorigin="anonymous" referrerpolicy="no-referrer" 
                />
                <a href='/'>
                    <img className={style.logo} src={vipaLogo} alt="logo"/>
                </a>
                <div className={style.paws} />
                <div className={style.info}>
                    <div className={style.info_pages}>
                        <a href="/#history"><h1>O VIPA</h1></a>
                        <a href="/animais"><h1>QUERO ADOTAR</h1></a>
                        <a href="/#donation"><h1>QUERO AJUDAR</h1></a>
                    </div>
                    <div className={style.hamburger}>
                        <i class="fa-solid fa-bars fa-rotate-180 fa-2x"
                            onClick={handleHambContent} 
                        />
                    </div>
                </div>
            </div>
            <div className={style.hamb_content} ref={hambContentRef}>
                <a href="/#history"><h1>O VIPA</h1></a>
                <a href="/animais"><h1>QUERO ADOTAR</h1></a>
                <a href="/#donation"><h1>QUERO AJUDAR</h1></a>

                <img className={style.dropdown_paws} src={dropdownImg} alt=""/>

                <div className={style.hamb_footer}>
                    {props.phone && (
                        <div className={style.contact}>
                            <a target="_blank" rel="noreferrer" href={`https://wa.me/${props.phone}`}>
                                <img className={style.whatsapp_icon} src={whatsappIcon} alt="whatsapp icon" />
                            </a>
                            <h2>{props.phone}</h2>
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}